
import { ExamVersionInfo } from "@/lib/model/exambuilder/exam-component/exam";
import HinaRadioGroup from "@/views/ai-builder-component/baseComponent/hina-radio-group.vue";
import { Component, Vue, Prop } from "vue-property-decorator";

@Component({
  components: {
    HinaRadioGroup
  }
})
export default class StoreSet extends Vue {
  @Prop() formItemData!: ExamVersionInfo; // 组件数据

  channelTypeOption = [
    { name: "阿里云对象存储", value: "aliyun" },
    { name: "腾讯云智能视图计算平台(MPS)", value: "iss" },
    { name: "腾讯云智能视图计算平台(ASR)", value: "iss2" },
    { name: "腾讯云实时音视频", value: "trtc" }
  ];

  uploadTypeOption = [
    { name: "阿里云oss", value: "aliyun" },
    { name: "腾讯云cos", value: "cos" }
  ];

  formItemCheck() {
    return new Promise((resolve, reject) => {
      if (
        this.formItemData.channelConfig.channelType &&
        this.formItemData.channelConfig.uploadType
      ) {
        resolve("");
      } else {
        resolve("storeSet");
      }
    });
  }
}
